/**
 * CWR 1.3 — Upcoming Bookings (simplified, tap-through; mockup :1810–1843).
 * Each card is one tap target → the booking detail. No inline actions, no maps,
 * no payment tap (those live on the detail page). Renders nothing when empty.
 */
import type { UpcomingBooking } from '@/types/dashboard';
import { BookingCard } from '@/components/client/BookingCard/BookingCard';
import { ChevronRightIcon } from './icons';
import styles from '../BookingHubPage.module.css';

export interface UpcomingListProps {
  bookings: UpcomingBooking[];
  onOpen: (id: string) => void;
  onViewAll: () => void;
}

export function UpcomingList({ bookings, onOpen, onViewAll }: UpcomingListProps) {
  if (bookings.length === 0) return null;

  return (
    <section className={styles.section} data-testid="home-upcoming">
      <div className={styles.sectionHeader}>
        <h2 className={styles.sectionTitle}>Upcoming Bookings</h2>
        <button type="button" className={styles.sectionLink} onClick={onViewAll}>
          View all
          <ChevronRightIcon />
        </button>
      </div>

      {bookings.map((booking) => (
        <BookingCard key={booking.id} booking={booking} onOpen={onOpen} variant="compact" />
      ))}
    </section>
  );
}
